import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Form, Formik } from "formik";
import Button from "../Button/Button";
import XmlSection from "../XmlViewer/XmlViewer";
import generateNumber from "../../utils/Functions/GenerateRandomNo";
import FTXml from "../../utils/Functions/FundTransferXml";
import FTPayload from "../../utils/Functions/FundTransferPayload";
import FTInitialValues from "../../utils/Functions/FundTransferInitialValues";
import XmlCovert from "../../utils/Functions/XmlCoverter";
import formatDate from "../../utils/Functions/FormatDate";
import FTFixedValues from "../../utils/Functions/FTFixedValues";
import FTDefaultValues from "../../utils/Functions/FTDefaultValues";
import SwitchSection from "../Toggle/SwitchSection";
import { disableFunction } from "../../utils/Functions/DefaultFunctions";
import FundTransferFields from "./FundTransferFields";
import { FundTransferSchema } from "../../utils/validation";

const FundTransfer = (props) => {
  const {
    goToStatusQuery,
    goToNameEquiry,
    isSending,
    sendSuccess,
    sendFundTransferValues,
    nameEnquiryData,
    fundTransferData,
    clearSuccessState,
  } = props;

  const [state, setState] = useState({
    fundTransfer: {},
    retryCheck: false,
  });

  let newTimeStamp = formatDate();

  useEffect(() => {
    generateNumber(setState, state);
    // eslint-disable-next-line
  }, []);

  const defaultValues = FTDefaultValues();

  const setDefaultValues = () => {
    setState({
      fundTransfer: defaultValues,
      random_number: state.random_number,
    });
  };

  const removeDefaultValues = () => {
    setState({
      fundTransfer: {},
      random_number: state.random_number,
    });
  };

  const resetForm = () => {
    clearSuccessState();
    setState({
      fundTransfer: {},
      retryCheck: true,
      random_number: state.random_number,
    });
  };

  const fixedValues = FTFixedValues(
    nameEnquiryData,
    XmlCovert,
    newTimeStamp,
    state.random_number
  );

  const initialValues = FTInitialValues(state, fixedValues);

  const handleSubmit = (values) => {
    const name = "funds-transfer";
    const payload = FTPayload(values, state, fixedValues);
    sendFundTransferValues(name, payload);
  };

  const xml = (values) => {
    const updateValues = FTXml(
      values,
      initialValues,
      fixedValues,
      state.random_number
    );
    return updateValues;
  };

  const xmlSuccess = fundTransferData && fundTransferData;

  return (
    <div>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={FundTransferSchema}
      >
        {({ values }) => {
          const disable = disableFunction(values);

          return (
            <Form id="form">
              <div className="nip-home-interaction-env">
                <div className="nip-home-interaction-env-left">
                  <SwitchSection
                    name="Fund Transfer"
                    goToFunction={goToNameEquiry}
                    setDefaultValues={setDefaultValues}
                    removeDefaultValues={removeDefaultValues}
                    retryCheck={state.retryCheck}
                  />

                  <div className="nip-form">
                    <FundTransferFields
                      time_stamp={fixedValues.time_stamp}
                      random_number={fixedValues.random_number}
                    />
                    {!sendSuccess ? (
                      <Button
                        testId="submitFT"
                        type="submit"
                        onClick={() => handleSubmit(values)}
                        width="100%"
                        height="45px"
                        disabled={disable || isSending}
                        word={isSending ? "SENDING..." : "SEND REQUEST"}
                      />
                    ) : (
                      <Button
                        testId="proceedToSQ"
                        type="button"
                        width="100%"
                        height="45px"
                        onClick={() => goToStatusQuery()}
                        word={"PROCEED"}
                      />
                    )}
                  </div>
                </div>

                <XmlSection
                  xml={sendSuccess ? xmlSuccess : xml(values)}
                  url={"api.nibss.com/transaction/initialize"}
                  onClick={() => resetForm()}
                />
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

FundTransfer.propTypes = {
  clearSuccessState: PropTypes.func,
  fundTransferData: PropTypes.any,
  goToNameEquiry: PropTypes.func,
  goToStatusQuery: PropTypes.func,
  isSending: PropTypes.bool,
  nameEnquiryData: PropTypes.any,
  sendFundTransferValues: PropTypes.func,
  sendSuccess: PropTypes.bool,
};

export default FundTransfer;
